"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservedOfferDtoStatusEnum = void 0;
exports.instanceOfReservedOfferDto = instanceOfReservedOfferDto;
exports.ReservedOfferDtoFromJSON = ReservedOfferDtoFromJSON;
exports.ReservedOfferDtoFromJSONTyped = ReservedOfferDtoFromJSONTyped;
exports.ReservedOfferDtoToJSON = ReservedOfferDtoToJSON;
exports.ReservedOfferDtoToJSONTyped = ReservedOfferDtoToJSONTyped;
/**
 * @export
 */
exports.ReservedOfferDtoStatusEnum = {
    Draft: 'draft',
    UnderReview: 'under_review',
    Pending: 'pending',
    Reserved: 'reserved',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered',
    Withdrawn: 'withdrawn',
    Expired: 'expired',
    Closed: 'closed'
};
/**
 * Check if a given object implements the ReservedOfferDto interface.
 */
function instanceOfReservedOfferDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('reservationDeadline' in value) || value['reservationDeadline'] === undefined)
        return false;
    return true;
}
function ReservedOfferDtoFromJSON(json) {
    return ReservedOfferDtoFromJSONTyped(json, false);
}
function ReservedOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
        'reservationDeadline': json['reservationDeadline'],
    };
}
function ReservedOfferDtoToJSON(json) {
    return ReservedOfferDtoToJSONTyped(json, false);
}
function ReservedOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
        'reservationDeadline': value['reservationDeadline'],
    };
}
